import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInputLabel } from './FormInputLabel';

export const FormCheck = React.forwardRef((props, ref) => {
  const { label, error, menus, groupProps = {}, labelProps = {}, control, name, ...rest } = props;
  const { t } = useTranslation();

  // Controller를 사용하는 경우
  if (control && name) {
    return (
      <div className='flex flex-col gap-1'>
        {label && <FormInputLabel label={label} isRequired={rest.required} />}
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <FormGroup {...groupProps}>
              {menus.map((menu) => {
                // menu.value가 boolean인 경우와 다른 타입인 경우를 구분
                const isChecked =
                  menu.value === true
                    ? field.value === true
                    : menu.value === false
                    ? field.value === false
                    : field.value === menu.value;

                return (
                  <FormControlLabel
                    key={String(menu.value)}
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={(e) => {
                          if (e.target.checked) {
                            field.onChange(menu.value);
                          } else {
                            // 체크 해제 시 false 또는 undefined로 설정
                            field.onChange(menu.value === true ? false : undefined);
                          }
                        }}
                      />
                    }
                    label={t(menu.label)}
                    {...labelProps}
                  />
                );
              })}
            </FormGroup>
          )}
        />
        {error && <FormHelperText error>{error.message}</FormHelperText>}
      </div>
    );
  }

  // register를 직접 사용하는 경우 (하위 호환성)
  const { register } = rest;
  if (register) {
    const registerProps = typeof register === 'function' ? register(name || '') : register;
    return (
      <div className='flex flex-col gap-1'>
        {label && <FormInputLabel label={label} isRequired={rest.required} />}
        <FormGroup {...groupProps}>
          {menus.map((menu) => (
            <FormControlLabel
              key={menu.value}
              control={
                <Checkbox
                  {...registerProps}
                  checked={
                    registerProps?.value === menu.value || (menu.value === true && registerProps?.value === true)
                  }
                  onChange={(e) => {
                    if (registerProps?.onChange) {
                      registerProps.onChange(e);
                    }
                  }}
                />
              }
              label={t(menu.label)}
              {...labelProps}
            />
          ))}
        </FormGroup>
        {error && <FormHelperText error>{error.message}</FormHelperText>}
      </div>
    );
  }

  // 제어되지 않는 컴포넌트 (하위 호환성)
  return (
    <div className='flex flex-col gap-1'>
      {label && <FormInputLabel label={label} isRequired={rest.required} />}
      <FormGroup {...groupProps}>
        {menus.map((menu) => (
          <FormControlLabel key={menu.value} control={<Checkbox {...rest} />} label={t(menu.label)} {...labelProps} />
        ))}
      </FormGroup>
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </div>
  );
});

FormCheck.displayName = 'FormCheck';
